import { InvoiceActions } from '../actions/actionTypes'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = {}

const reducer = ReducerBuilder.create(INITIAL_STATE)
  .mapAction(InvoiceActions.SET_INVOICE, (StateType, payload) => payload)
  .build()

export default reducer
